(function(){
  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  var drawer = qs('#AmzQuickAddDrawer');
  if(!drawer) return;

  var content = qs('[data-amz-qad-content]', drawer);

  function qadSettings(){ return window.AMZ_QAD_SETTINGS || {}; }

  function settingText(key, fallback){
    var s = qadSettings();
    var value = s[key];
    if(value == null || value === '') return fallback;
    return String(value);
  }

  function settingBool(key, fallback){
    var s = qadSettings();
    if(typeof s[key] === 'boolean') return s[key];
    if(s[key] == null) return fallback;
    return !!s[key];
  }

  function addBehavior(){
    var behavior = settingText('behavior', 'quick_drawer');
    if(behavior === 'cart_drawer' || behavior === 'checkout') return behavior;
    return 'quick_drawer';
  }

  function setTriggerLoading(btn, loading){
    if(!btn) return;
    if(loading){
      btn.__amzQadOriginalText = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-amz-qad-busy', 'true');
      btn.textContent = settingText('addingLabel', 'Adding...');
      return;
    }
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.removeAttribute('data-amz-qad-busy');
    btn.textContent = btn.__amzQadOriginalText || settingText('triggerLabel', 'Add to cart');
    btn.__amzQadOriginalText = '';
  }

  function syncTriggerVariantFromSwatch(swatch){
    if(!swatch) return;
    var variantId = swatch.getAttribute('data-amz-qad-variant-id');
    if(!variantId) return;
    var card = swatch.closest('.amz-gp') || swatch.closest('.grid__item');
    if(!card) return;
    var trigger = qs('.amz-qad-trigger', card);
    if(trigger) trigger.setAttribute('data-amz-qad-variant-id', variantId);
  }

  async function addVariantToCart(variantId){
    var response = await fetch((window.apx && apx.routes && apx.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: Number(variantId), quantity: 1})
    });
    var item = null;
    try{ item = await response.json(); }catch(e){}
    if(!response.ok){
      var message = item && (item.description || item.message);
      throw new Error(message || 'Unable to add this product to the cart.');
    }
    return item;
  }

  function announceCartItem(item){
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:item, item:item}}));
    document.dispatchEvent(new CustomEvent('cart:open'));
    fetch((window.apx && apx.routes && apx.routes.cart) || '/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(response){ return response.json(); })
      .then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart:cart}}));
      })
      .catch(function(){});
  }

  async function runDirectTriggerAction(btn, behavior){
    if(!btn || btn.getAttribute('data-amz-qad-busy') === 'true') return;
    var variantId = btn.getAttribute('data-amz-qad-variant-id');
    if(!variantId) return;
    setTriggerLoading(btn, true);
    try{
      var item = await addVariantToCart(variantId);
      if(behavior === 'checkout'){
        window.location.assign(((window.apx && apx.routes && apx.routes.localeRoot) || '/') + 'checkout');
        return;
      }
      if(!qs('#CartDrawer')){
        window.location.assign((window.apx && apx.routes && apx.routes.cartPage) || '/cart');
        return;
      }
      announceCartItem(item);
      window.setTimeout(function(){ setTriggerLoading(btn, false); }, 700);
    }catch(error){
      btn.textContent = error && error.message ? error.message : 'Unable to add this product to the cart.';
      window.setTimeout(function(){ setTriggerLoading(btn, false); }, 1800);
    }
  }

  function addButtonText(variant){
    var label = settingText('addLabel', 'ADD TO CART');
    if(!variant) return label;
    if(!variant.available) return settingText('soldoutLabel', 'Sold out');
    if(settingBool('addShowPrice', true)){
      return label + settingText('addPriceSeparator', ' · ') + formatMoneyCents(variant.price);
    }
    return label;
  }

  function applyTriggerLabels(root){
    qsa('.amz-qad-trigger', root || document).forEach(function(btn){
      if(btn.disabled || btn.getAttribute('aria-disabled') === 'true'){
        btn.textContent = settingText('triggerSoldoutLabel', 'Sold out');
      }else{
        btn.textContent = settingText('triggerLabel', 'Add to cart');
      }
    });
  }

  function openDrawer(){
    drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('amz-qad-open');
  }

  function closeDrawer(){
    drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('amz-qad-open');
  }

  function truncateText(s, max){
    if(!s) return '';
    var t = String(s).trim();
    if(max && t.length > max) return t.slice(0, max).trim() + '…';
    return t;
  }

  function formatMoneyCents(cents){
    try{
      if(window.apx && apx.settings && apx.settings.moneyFormat && window.Shopify && Shopify.formatMoney){
        return Shopify.formatMoney(cents, apx.settings.moneyFormat);
      }
    }catch(e){}
    return (cents/100).toFixed(2);
  }

  function uniqueValues(list){
    var out=[], seen={};
    list.forEach(function(v){
      if(v == null) return;
      var k = String(v);
      if(!seen[k]){ seen[k]=true; out.push(k); }
    });
    return out;
  }

  function findVariantByOptions(product, selected){
    for(var i=0;i<product.variants.length;i++){
      var v = product.variants[i];
      var ok = true;
      for(var j=0;j<selected.length;j++){
        if(v.options[j] !== selected[j]){ ok=false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  function getOptionName(raw){
    if(raw && typeof raw === 'object'){
      return raw.name || raw.label || raw.public_name || raw.option_name || '';
    }
    return raw || '';
  }

  function normalizeOptionName(name){
    return String(name || '').toLowerCase();
  }

  function optionIsColor(name){
    var n = normalizeOptionName(name);
    var triggers = ['color','colour','farve','couleur','farbe','colore','kleur','coloris','cor','kolor','цвет','색','色','顏色'];
    for(var i=0;i<triggers.length;i++){
      if(n.indexOf(triggers[i]) !== -1) return true;
    }
    return false;
  }

  function getVariantImageSrc(v){
    if(!v) return '';
    if(typeof v.featured_image === 'string') return v.featured_image;
    if(v.featured_image && typeof v.featured_image === 'object'){
      return v.featured_image.src || v.featured_image.url || v.featured_image.originalSrc || '';
    }
    if(typeof v.image === 'string') return v.image;
    if(v.image && typeof v.image === 'object'){
      return v.image.src || v.image.url || v.image.originalSrc || '';
    }
    return '';
  }

  function escapeAttr(s){
    return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function buildVariantSelectors(product, selectedVariant){
    if(!product.options || product.options.length === 0) return '';

    var html = '<div class="amz-qad__variants" data-amz-qad-variants>';
    var selected = (selectedVariant && selectedVariant.options) ? selectedVariant.options.slice() : product.variants[0].options.slice();

    for(var i=0;i<product.options.length;i++){
      var name = getOptionName(product.options[i]);
      if(!name) name = 'Option ' + (i+1);

      var values = uniqueValues(product.variants.map(function(v){ return v.options[i]; }));
      var isColor = optionIsColor(name);

      html += '<div class="amz-qad__variant-group" data-amz-qad-group data-amz-qad-group-index="' + i + '">';
      html += '<div class="amz-qad__variant-label">' + name + '</div>';

      if(isColor){
        html += '<div class="amz-qad__swatches" role="radiogroup" aria-label="' + escapeAttr(name) + '">';
        values.forEach(function(val){
          var vForImg = null;
          for(var k=0;k<product.variants.length;k++){
            if(product.variants[k].options[i] === val){
              var src = getVariantImageSrc(product.variants[k]);
              if(src){ vForImg = product.variants[k]; break; }
            }
          }
          var imgSrc = vForImg ? getVariantImageSrc(vForImg) : (product.featured_image || '');
          var active = (selected[i] === val) ? ' is-active' : '';
          var checked = (selected[i] === val) ? 'true' : 'false';
          html += '<button type="button" class="amz-qad__swatch' + active + '" data-amz-qad-option-index="' + i + '" data-amz-qad-option-value="' + escapeAttr(val) + '" role="radio" aria-checked="' + checked + '">';
          if(imgSrc){
            html += '<img src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(val) + '" loading="lazy">';
          }else{
            html += '<span class="amz-qad__swatch-fallback">' + val + '</span>';
          }
          html += '</button>';
        });
        html += '</div>';
      }else{
        html += '<div class="amz-qad__option-buttons" role="radiogroup" aria-label="' + escapeAttr(name) + '">';
        values.forEach(function(val){
          var active = (selected[i] === val) ? ' is-active' : '';
          var checked = (selected[i] === val) ? 'true' : 'false';
          html += '<button type="button" class="amz-qad__option-btn' + active + '" data-amz-qad-option-index="' + i + '" data-amz-qad-option-value="' + escapeAttr(val) + '" role="radio" aria-checked="' + checked + '">' + val + '</button>';
        });
        html += '</div>';
      }

      html += '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderProduct(p, productUrl){
    var s = qadSettings();
    var v0 = p.variants && p.variants.length ? p.variants.find(function(v){ return v.available; }) || p.variants[0] : null;

    var priceHtml = v0 ? formatMoneyCents(v0.price) : '';

    var desc = truncateText((p.description || '').replace(/<[^>]*>/g,' ').replace(/\s+/g,' '), s.descLimit || 160);

    var html = '';
    if(s.showImage){
      html += '<div class="amz-qad__media"><img data-amz-qad-media-img src="' + ((v0 && getVariantImageSrc(v0)) || (p.featured_image || '')) + '" alt=""></div>';
    }
    if(s.showTitle){
      html += '<div class="amz-qad__title">' + (p.title || '') + '</div>';
    }
    if(s.showPrice){
      html += '<div class="amz-qad__price" data-amz-qad-price>' + priceHtml + '</div>';
    }

    if(s.showVariants && p.variants && p.variants.length > 1){
      html += buildVariantSelectors(p, v0);
    }

    if(s.showDesc && desc){
      html += '<div class="amz-qad__desc">' + desc + '</div>';
    }

    var vid = v0 ? v0.id : '';
    var disabled = (!v0 || !v0.available) ? ' disabled' : '';
    html += '<button type="button" class="amz-qad__add" data-amz-qad-add data-variant-id="' + vid + '"' + disabled + '>' + escapeAttr(addButtonText(v0)) + '</button>';
    if(settingBool('showView', true)){
      html += '<button type="button" class="amz-qad__view" data-amz-qad-view>' + escapeAttr(settingText('viewLabel', 'View full product')) + '</button>';
    }

    content.innerHTML = html;

    function getSelectedFromState(){
      if(!content.__amzQadSelected){
        content.__amzQadSelected = (v0 && v0.options) ? v0.options.slice() : (p.variants[0] ? p.variants[0].options.slice() : []);
      }
      return content.__amzQadSelected;
    }

    function variantMatchesWithOverride(variant, selected, overrideIndex, overrideValue){
      for(var i=0;i<variant.options.length;i++){
        var want = (i === overrideIndex) ? overrideValue : selected[i];
        if(want == null) continue;
        if(variant.options[i] !== want) return false;
      }
      return true;
    }

    function findVariantByPartial(product, selected){
      var firstMatch = null;
      var firstAvail = null;
      for(var i=0;i<product.variants.length;i++){
        var v = product.variants[i];
        if(!variantMatchesWithOverride(v, selected, -1, null)) continue;
        if(!firstMatch) firstMatch = v;
        if(v.available){ firstAvail = v; break; }
      }
      return firstAvail || firstMatch;
    }

    function updateDisabledStates(){
      var selected = getSelectedFromState();
      var buttons = qsa('[data-amz-qad-option-index][data-amz-qad-option-value]', content);

      buttons.forEach(function(btn){
        var idx = Number(btn.getAttribute('data-amz-qad-option-index'));
        var val = btn.getAttribute('data-amz-qad-option-value');
        var ok = false;

        for(var i=0;i<p.variants.length;i++){
          var v = p.variants[i];
          if(!v.available) continue;
          if(variantMatchesWithOverride(v, selected, idx, val)){ ok = true; break; }
        }

        btn.disabled = !ok;
        if(!ok){
          btn.classList.add('is-disabled');
          btn.setAttribute('aria-disabled','true');
        }else{
          btn.classList.remove('is-disabled');
          btn.removeAttribute('aria-disabled');
        }
      });
    }

    function syncUIToSelected(){
      var selected = getSelectedFromState();
      var variant = findVariantByOptions(p, selected);

      if(!variant){
        var best = findVariantByPartial(p, selected);
        if(best){
          content.__amzQadSelected = best.options.slice();
          selected = getSelectedFromState();
          variant = best;
        }
      }

      qsa('[data-amz-qad-option-index][data-amz-qad-option-value]', content).forEach(function(btn){
        var idx = Number(btn.getAttribute('data-amz-qad-option-index'));
        var val = btn.getAttribute('data-amz-qad-option-value');
        var isActive = (selected[idx] === val);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      updateDisabledStates();

      var addBtn = qs('[data-amz-qad-add]', content);
      var priceEl = qs('[data-amz-qad-price]', content);
      var mediaImg = qs('[data-amz-qad-media-img]', content);

      if(variant){
        if(priceEl) priceEl.textContent = formatMoneyCents(variant.price);

        if(addBtn){
          addBtn.setAttribute('data-variant-id', variant.id);
          addBtn.disabled = !variant.available;
          addBtn.textContent = addButtonText(variant);
        }

        if(mediaImg){
          var src = getVariantImageSrc(variant) || p.featured_image || '';
          if(src) mediaImg.setAttribute('src', src);
        }
      }else{
        if(addBtn){
          addBtn.disabled = true;
          addBtn.textContent = settingText('addLabel', 'ADD TO CART');
        }
      }
    }

    content.addEventListener('click', function(ev){
      var btn = ev.target.closest('[data-amz-qad-option-index][data-amz-qad-option-value]');
      if(!btn) return;
      ev.preventDefault();
      var idx = Number(btn.getAttribute('data-amz-qad-option-index'));
      var val = btn.getAttribute('data-amz-qad-option-value');

      var selected = getSelectedFromState();
      selected[idx] = val;
      content.__amzQadSelected = selected;

      var best = findVariantByPartial(p, selected);
      if(best){
        content.__amzQadSelected = best.options.slice();
      }

      syncUIToSelected();
    });

    syncUIToSelected();

    var addBtn = qs('[data-amz-qad-add]', content);
    var viewBtn = qs('[data-amz-qad-view]', content);

    async function refreshCartDrawer(){
      try{
        var r = await fetch(((window.apx && apx.routes && apx.routes.localeRoot) || '/') + '?sections=cart-drawer', {headers:{'Accept':'application/json'}});
        if(!r.ok) return;
        var j = await r.json();
        var html = '';
        if(j){
          if(j['cart-drawer']) html = j['cart-drawer'];
          else {
            for(var k in j){ if(j[k]){ html = j[k]; break; } }
          }
        }
        if(!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#CartDrawer') || doc.querySelector('[data-cart-drawer]') || doc.querySelector('.cart-drawer') || doc.body.firstElementChild;
        var curDrawer = document.querySelector('#CartDrawer') || document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer');

        if(newDrawer && curDrawer){
          curDrawer.replaceWith(newDrawer);
          try{
            if(window.apx && typeof apx.CartDrawer === 'function'){
              new apx.CartDrawer();
            }
          }catch(e){}
        }
      }catch(e){}
    }

    function tryOpenCartDrawer(){
      var opener = document.querySelector('.js-drawer-open-cart[aria-controls="CartDrawer"]') || document.querySelector('.js-drawer-open-cart');
      if (opener) {
        var preventNav = function(ev){
          try{
            ev.preventDefault();
            ev.stopPropagation();
            if(ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          }catch(e){}
          return false;
        };
        var isLink = opener.tagName && opener.tagName.toLowerCase() === 'a';
        var href = (opener.getAttribute && opener.getAttribute('href')) ? opener.getAttribute('href') : '';
        if (isLink || (href && href.indexOf('/cart') === 0)) {
          opener.addEventListener('click', preventNav, { capture: true, once: true });
        }

        try {
          var evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
          opener.dispatchEvent(evt);
        } catch (e) {
          try { opener.click(); } catch (e2) {}
        }
      }

      setTimeout(function () {
        var drawerEl = document.querySelector('#CartDrawer');
        if (!drawerEl) return;

        var isOpen = drawerEl.getAttribute('aria-hidden') === 'false' || drawerEl.classList.contains('drawer--is-open') || drawerEl.classList.contains('is-open');
        if (isOpen) return;

        try {
          drawerEl.setAttribute('aria-hidden', 'false');
          drawerEl.classList.add('drawer--is-open', 'is-open');
          drawerEl.style.right = '0';
          drawerEl.style.transform = 'translate3d(0,0,0)';
          drawerEl.style.visibility = 'visible';
          drawerEl.style.pointerEvents = 'auto';

          document.documentElement.classList.add('js-drawer-open', 'js-drawer-open-cart');
          document.body.classList.add('js-drawer-open', 'js-drawer-open-cart');

          var overlay = document.querySelector('.drawer__overlay.amz-qad-cart-overlay');
          if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'drawer__overlay js-drawer-close amz-qad-cart-overlay';
            document.body.appendChild(overlay);
          }

          var closeFn = function () {
            try {
              drawerEl.setAttribute('aria-hidden', 'true');
              drawerEl.classList.remove('drawer--is-open', 'is-open');
              drawerEl.style.right = '';
              drawerEl.style.transform = '';
              drawerEl.style.visibility = '';
              drawerEl.style.pointerEvents = '';
              document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open-cart');
              document.body.classList.remove('js-drawer-open', 'js-drawer-open-cart');
              var ov = document.querySelector('.drawer__overlay.amz-qad-cart-overlay');
              if (ov) ov.remove();
            } catch (e) {}
          };

          overlay.addEventListener('click', closeFn, { once: true });
          document.addEventListener('keydown', function (ev) {
            if (ev.key === 'Escape') closeFn();
          }, { once: true });

          var btnClose = drawerEl.querySelector('.js-drawer-close');
          if (btnClose) {
            btnClose.addEventListener('click', function () {
              closeFn();
            }, { once: true });
          }
        } catch (e) {}
      }, 80);

      return true;
    }

    if(addBtn){
      addBtn.addEventListener('click', async function(){
        var vid = this.getAttribute('data-variant-id');
        if(!vid) return;
        var originalText = this.textContent;
        this.disabled = true;
        this.textContent = settingText('addingLabel', 'Adding...');

        try{
          var res = await fetch((window.apx && apx.routes && apx.routes.cartAdd) || '/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({id: Number(vid), quantity: 1})
          });

          if(!res.ok){
            this.disabled = false;
            this.textContent = originalText;
            return;
          }

          await refreshCartDrawer();

          try{
            var cartRes = await fetch((window.apx && apx.routes && apx.routes.cart) || '/cart.js', {headers:{'Accept':'application/json'}});
            var cart = await cartRes.json();
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{cart: cart}}));
            document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart: cart}}));
          }catch(e){}

          closeDrawer();

          await new Promise(function(r){ setTimeout(r, 60); });

          tryOpenCartDrawer();
        }catch(e){
          this.disabled = false;
          this.textContent = originalText;
        }
      });
    }

    if(viewBtn){
      viewBtn.addEventListener('click', function(){
        window.location.href = productUrl;
      });
    }
  }

  function loadAndOpen(handle, url){
    content.innerHTML = '<div style="padding:18px 0;">' + escapeAttr(settingText('loadingLabel', 'Loading...')) + '</div>';
    openDrawer();
    fetch(((window.apx && apx.routes && apx.routes.localeRoot) || '/') + 'products/' + handle + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(p){ renderProduct(p, url); })
      .catch(function(){ window.location.href = url; });
  }

  applyTriggerLabels();

  if(window.MutationObserver){
    var triggerObserver = new MutationObserver(function(mutations){
      var shouldApply = false;
      mutations.forEach(function(mutation){
        if(shouldApply) return;
        mutation.addedNodes && Array.prototype.slice.call(mutation.addedNodes).forEach(function(node){
          if(shouldApply || !node || node.nodeType !== 1) return;
          if(node.classList && node.classList.contains('amz-qad-trigger')) shouldApply = true;
          else if(node.querySelector && node.querySelector('.amz-qad-trigger')) shouldApply = true;
        });
      });
      if(shouldApply) applyTriggerLabels();
    });
    triggerObserver.observe(document.documentElement, {childList:true, subtree:true});
  }

  document.addEventListener('shopify:section:load', function(e){ applyTriggerLabels(e.target); });

  document.addEventListener('click', function(e){
    var swatch = e.target.closest('.amz-grid-swatch[data-amz-qad-variant-id]');
    if(swatch) syncTriggerVariantFromSwatch(swatch);

    var openBtn = e.target.closest('.js-amz-qad-open');
    if(openBtn){
      e.preventDefault();
      e.stopPropagation();
      if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      var behavior = addBehavior();
      if(behavior === 'cart_drawer' || behavior === 'checkout'){
        runDirectTriggerAction(openBtn, behavior);
        return;
      }
      var handle = openBtn.getAttribute('data-amz-qad-handle');
      var url = openBtn.getAttribute('data-amz-qad-url') || (((window.apx && apx.routes && apx.routes.localeRoot) || '/') + 'products/' + handle);
      if(handle) loadAndOpen(handle, url);
      return;
    }
    if(e.target.closest('[data-amz-qad-close]')){
      e.preventDefault();
      closeDrawer();
      return;
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false'){
      closeDrawer();
    }
  });
})();
